<!-- 创建商品 -->
<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{ name: 'khgl_khgl_khxx' }" style="position: absolute;top: 12px;left: 200px;"><el-button size="mini">回到客户列表</el-button></router-link>

		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 35%;">
					<el-form-item label="* 客户名称"><el-input v-model="lists.mc" style="width: 90%;" :disabled="true"></el-input></el-form-item>
					<el-form-item label="手机号码"><el-input v-model="lists.sjhm" style="width: 90%;" :disabled="true"></el-input></el-form-item>
					<el-form-item label="地区"><el-input v-model="lists.dq" placeholder="如:广东-广州" style="width: 90%;" :disabled="true"></el-input></el-form-item>
					<el-form-item label="责任人">
						<el-select v-model="lists.zrr" filterable placeholder="请选择" :disabled="true">
							<el-option v-for="item in yhs" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="备注"><el-input v-model="lists.desc" style="width: 90%;" :disabled="true"></el-input></el-form-item>
					<el-form-item label="电话号码"><el-input v-model="lists.dhhm" style="width: 90%;" :disabled="true"></el-input></el-form-item>
					<el-form-item label="详细地址"><el-input v-model="lists.xxdz" style="width: 90%;" :disabled="true"></el-input></el-form-item>
					<el-form-item label="共享商务">
						<el-select v-model="lists.gx" filterable placeholder="请选择" :disabled="true">
							<el-option v-for="item in yhs" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="联系人"><el-input v-model="lists.lxr" style="width: 90%;" :disabled="true"></el-input></el-form-item>
					<el-form-item label="电子邮件"><el-input v-model="lists.email" style="width: 90%;" :disabled="true"></el-input></el-form-item>
					<el-form-item label="客户状态">
						<el-select v-model="lists.khzt" placeholder="请选择" :disabled="true">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</div>
			</div>
		</el-form>
	</div>
</template>

<script>
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	inject: ['app', 'layout'],
	data() {
		return {
			lists: {},
			yhs: [],
			options: [
				{
					value: 0,
					label: '待开发'
				},
				{
					value: 1,
					label: '潜在客户'
				},
				{
					value: 2,
					label: '过期客户'
				},
				{
					value: 3,
					label: '问题客户'
				},
				{
					value: 4,
					label: '已成交'
				}
			]
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	// 生命周期
	created() {
		this.lists = this.$route.params.data;
		this.axios.get('/admin/managers/list', { token: true }).then(res => {
			this.yhs = res.data.data;
		});
	},
	methods: {
		onClick(e, editor) {},
		handleChange(value) {},
	}
};
</script>

<style>
.goods_create .el-form-item {
	margin-bottom: 15px;
}
.pt-a {
	padding-top: 20px;
}
</style>
